// extracted by mini-css-extract-plugin
module.exports = {"stepsHeader":"RYR2h","headerItem":"HdmwN","image":"Aojzl","dot":"_5MWfy","number":"styW3","current":"x2apQ"};